@if (!isViewInvoiceRoute()) {
  <div class="outer-wrapper" igxLayout>
    <igx-nav-drawer #nav id="project-menu" [isOpen]="this._appGeneralState.navMenuDisplay" [enableGestures]="true" [width]="'330px'" >
      <ng-template igxDrawer [height]="'2000px'" [width]="'830px'">
          <div class="container-full">
            <div class="app-shared-header" [ngClass]="this._appGeneralState.isEnvironmentDev ? 'ace-navbar-dev': 'ace-navbar-production'">
              <div class="col-12 app-drawer-header-content">
                  
                  <img src="../assets/images/SPACE AR small.png" style="height:50px;margin-left:50px;position:relative;top:-3px;" (click)="onNavToHome()"/>

                  <span *ngIf="this._appGeneralState.navMenuDisplay"
                    class="material-icons mimic-button-hover" style="color:black;position:relative;top:4px;margin-left:40px;color:white" (click)="this._appGeneralState.toggleNavMenuDisplay()">
                    keyboard_double_arrow_left
                    </span>
                  
              </div>
            </div>
          </div>
          <app-nav-sidebar style="position:relative;left:-30px;top:-10px;height:1500px;"></app-nav-sidebar>

      </ng-template>
    </igx-nav-drawer>
    <div igxFlex igxLayout igxLayoutDir="columns" style="height:1000px;">
        <div class="app-shared-header" [ngClass]="this._appGeneralState.isEnvironmentDev ? 'ace-navbar-dev': 'ace-navbar-production'">
              <div class="container-full">
              <div class="row app-main-header-row">
                      <div class="col-2">
                        <button mat-icon-button color="accent" aria-label="Example icon button with a menu icon"  (click)="this._appGeneralState.toggleNavMenuDisplay()" style="margin-top:0;margin-left:5px;height:50px;width:50px;" *ngIf="!this._appGeneralState.navMenuDisplay">
                          <mat-icon style="color:white;">menu</mat-icon>
                        </button>

                        <img  *ngIf="!this._appGeneralState.navMenuDisplay" 
                          src="../../../../assets/images/SPACE AR small.png"
                          width="120px" height="50px" alt="" style="position:relative;top:-8px;" 
                        (click)="onNavToHome()">
                      </div>

                      <div class="col-4">
                        <div class="row">
          
                        

                          <div class="col-12" style="margin-top:0;margin-left:0px;" *ngIf="this._appGeneralState.canChangeLot">
                            <span class="material-icons mimic-button-hover" style="color:white;margin-left:10px;position:relative;top:5px;" (click)="onChooseLot()">
                              emoji_transportation
                            </span>
                            <span style="color:white;margin-left:10px;font-size:18px;" class="ace-heading-text-primary mimic-button-hover"  (click)="onChooseLot()">{{this._appGeneralState.getCurrentLotNumberNameDisplay()}}</span>
                          </div>

                          <div class="col-12" style="margin-top:0;margin-left:0px;" *ngIf="!this._appGeneralState.canChangeLot" >
                            <span class="material-icons mimic-button-hover" style="color:white;margin-left:10px;position:relative;top:0;" >
                              lock
                            </span>
                            <span style="color:white;margin-left:10px;font-size:18px;" class="ace-heading-text-primary mimic-button-hover"  matTooltip="The lot cannot be changed right now">{{this._appGeneralState.getCurrentLotNumberNameDisplay()}}</span>
                          </div>

                        </div>
                      </div>

                      <!-- <div class="col-1 text-end">
                        <button
                          mat-button
                          [matMenuTriggerFor]="notificationMenu"
                          class="notification-trigger"
                          aria-label="Open notifications"
                        >
                          <span class="material-icons notification-trigger__icon">
                            {{ notifications.length > 0 ? 'notifications_active' : 'notifications_none' }}
                          </span>
                          <span class="ace-heading-text-primary notification-trigger__label">
                            {{ notifications.length }} {{ notifications.length === 1 ? 'New Alert' : 'New Alerts' }}
                          </span>
                        </button>

                        <mat-menu #notificationMenu="matMenu" panelClass="notification-menu-panel" xPosition="before">
                          <div class="notification-menu" (click)="$event.stopPropagation()">
                            <div class="notification-menu__header">Alerts</div>

                            <ng-container *ngIf="notifications.length; else emptyNotifications">
                              <ng-container *ngFor="let notification of notifications; let isLast = last">
                                <div class="notification-item">
                                  <button
                                    mat-icon-button
                                    type="button"
                                    color="primary"
                                    class="notification-item__dismiss"
                                    aria-label="Dismiss notification"
                                    (click)="dismissNotification(notification.id)"
                                  >
                                    <mat-icon>cancel</mat-icon>
                                  </button>
                                  <div class="notification-item__message">{{ notification.message }}</div>
                                </div>
                                <mat-divider *ngIf="!isLast"></mat-divider>
                              </ng-container>
                            </ng-container>

                            <ng-template #emptyNotifications>
                              <div class="notification-item notification-item--empty">
                                No new alerts.
                              </div>
                            </ng-template>
                          </div>
                        </mat-menu>
                      </div> -->

                  </div>

                  <div class="app-header-actions">
                    <div class="app-header-user">
                      <span class="material-icons">account_circle</span>
                      <span class="ace-heading-text-primary">{{this._appGeneralState.userName}}</span>
                    </div>
                    <button mat-button type="button" class="app-header-logout" (click)="onLogOut()">
                      <span class="material-icons">logout</span>
                      <span class="ace-heading-text-primary">Logout</span>
                    </button>
                    <img class="app-header-brand" src="../assets/images/ace-deep-blue-header.png" alt="ACE Deep Blue"/>
                  </div>

              </div>
      </div>
      <div class="content" igxFlex> 
        @if(_appGeneralState.isProcessing){
              <!-- <div style="margin-top:30px;"> -->
                <!-- <span class="d-flex justify-content-center align-items-center"> -->
                  <!-- <router-outlet></router-outlet> -->
                <!-- </span> -->
              <!-- </div> -->
          }
          @else
          {
            <router-outlet></router-outlet>
          }
      </div>
      </div>
  </div>
}
@else {
  <router-outlet></router-outlet>
}
   



